import {
  colors,
  font_weight,
  new_typography,
  opacity,
  spacing,
} from '@lamimed/pantheon';
import Link from 'next/link';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const Crumb = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${rgba(colors.text__primary, opacity.medium)};

  p {
    margin-left: 0.6rem;
    color: ${rgba(colors.text__primary, opacity.medium)};
  }
`;

type ContainerProps = {
  marginBottom: keyof typeof spacing;
};

export const Container = styled.div<ContainerProps>`
  ${({ marginBottom }) => css`
    display: flex;
    margin-bottom: ${spacing[marginBottom]};

    ${Crumb}:not(:first-child)::before {
      ${new_typography.body_text_3};

      content: '/';
      margin: 0 0.5rem;
      font-weight: ${font_weight.light};
    }

    ${Crumb}:not(:last-child):hover {
      p {
        text-decoration: underline;
      }
    }

    ${Crumb}:last-child {
      color: ${colors.text__primary};

      p {
        color: ${colors.text__primary};
      }
    }
  `};
`;
